export const INVESTIGATION_METRICS_RANGES = ['last_4_weeks', 'last_12_weeks', 'since_driver_started'] as const;

export type InvestigationMetricsRange = (typeof INVESTIGATION_METRICS_RANGES)[number];

export const DEFAULT_INVESTIGATION_METRICS_RANGE: InvestigationMetricsRange = 'last_4_weeks';

export interface MetricsPeriod {
  start: string;
  end: string;
}

export interface ResolutionMetrics {
  ticket_count: number;
  median_seconds: number | null;
  p90_seconds: number | null;
}

export interface ReopenMetrics {
  resolved_count: number;
  reopened_count: number;
  rate: number | null;
}

export interface ThroughputMetrics {
  closes: number;
  engineer_days: number;
  closes_per_engineer_day: number | null;
}

export interface AdoptionMetrics {
  resolved_count: number;
  investigated_count: number;
  rate: number | null;
}

export interface FeedbackMetrics {
  investigated_count: number;
  rated_count: number;
  coverage: number | null;
  ratings: Record<string, number>;
}

export interface MetricsWeek {
  start: string;
  end: string;
  time_to_resolution: ResolutionMetrics;
}

export interface InvestigationMetricsResponse {
  range: InvestigationMetricsRange;
  generated_at: string;
  first_investigation_at: string | null;
  baseline: MetricsPeriod | null;
  current: MetricsPeriod | null;
  time_to_resolution: { baseline: ResolutionMetrics | null; current: ResolutionMetrics | null };
  reopens: { baseline: ReopenMetrics | null; current: ReopenMetrics | null };
  throughput: { baseline: ThroughputMetrics | null; current: ThroughputMetrics | null };
  adoption: { current: AdoptionMetrics | null };
  feedback: { current: FeedbackMetrics | null };
  open_tickets: number;
  weekly: MetricsWeek[];
}
